import { Switch, Route } from "react-router-dom";
import { Box } from "@chakra-ui/layout";
import onboardingWave from "assets/images/svgs/onboarding-wave.svg";
import PrimeiroPasso from './PrimeiroPasso'
import SegundoPasso from './SegundoPasso'
import TerceiroPasso from './TerceiroPasso'
import QuartoPasso from './QuartoPasso'
import QuintoPasso from './QuintoPasso'

function Onboarding() {
    return(
        <Box 
            minH="100vh" 
            overflowX={"hidden"} 
            bg={"#E5E5E5"} 
            maxW="100vw" 
            style={{ backgroundImage: `url(${onboardingWave})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
        >
            <Switch>
                <Route path="/onboarding/primeiro-passo" component={PrimeiroPasso}/>
                <Route path="/onboarding/segundo-passo" component={SegundoPasso}/>
                <Route path="/onboarding/terceiro-passo" component={TerceiroPasso}/>
                <Route path="/onboarding/quarto-passo" component={QuartoPasso}/>
                <Route path="/onboarding/quinto-passo" component={QuintoPasso}/>
            </Switch>
        </Box>        
    )
}

export default Onboarding;